<template>
  <v-dialog :value="value" persistent max-width="500">
    <v-card rounded="lg">
      <v-card-title class="dialog-header white--text">
        <v-icon size="28" color="white" class="mr-3">mdi-account-check</v-icon>
        <div>
          <h3 class="mb-1">กำหนดผู้รับผิดชอบระบบ</h3>
          <p class="subtitle mb-0">ข้อมูลจำเป็นก่อนใช้งานต่อ</p>
        </div>
      </v-card-title>

      <v-card-text class="pa-6">
        <p class="mb-4">
          กรุณากรอกเลขบัตรประชาชนของผู้รับผิดชอบระบบของหน่วยงานท่าน — เลขบัตรนี้ต้องเป็นบุคคลที่มีข้อมูลอยู่ในระบบบุคลากร (personnel_etc) แล้วเท่านั้น
        </p>
        <v-alert v-if="errorMsg" type="error" dense outlined class="mb-4">{{ errorMsg }}</v-alert>
        <v-form ref="form" lazy-validation>
          <v-text-field
            v-model="idCard"
            label="เลขบัตรประชาชนผู้รับผิดชอบระบบ"
            prepend-icon="mdi-card-account-details"
            type="text"
            maxlength="13"
            :rules="[v => !!v || 'กรุณากรอกเลขบัตรประชาชน', v => /^[0-9]{13}$/.test(v) || 'ต้องเป็นตัวเลข 13 หลัก']"
            outlined
            rounded
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" rounded large :loading="loading" @click="submit">
          <v-icon left>mdi-content-save</v-icon>บันทึก
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// SetResponsiblePersonDialog.vue — บล็อกการใช้งานจนกว่าจะกำหนดผู้รับผิดชอบระบบ (บัญชี user_status B/C/G)
// เตรียมข้อมูลไว้สำหรับขยาย ThaiID 2FA มากลุ่มนี้ในอนาคต — เปิดใช้จาก college.vue/iven.vue/vecprovince.vue
export default {
  name: "SetResponsiblePersonDialog",
  props: {
    value: { type: Boolean, default: false }
  },
  data() {
    return {
      idCard: "",
      errorMsg: "",
      loading: false
    };
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      this.errorMsg = "";
      try {
        const result = await this.$http.post("user.set_responsible_person.php", {
          id_card: this.idCard
        });

        if (result.data && result.data.status) {
          // อัปเดต localStorage เพื่อไม่ให้ dialog เด้งซ้ำในเซสชันนี้ (ไม่ต้อง login ใหม่)
          const user = JSON.parse(localStorage.getItem("user")) || {};
          user.must_set_responsible_person = false;
          user.user_responsible_id_card = this.idCard;
          localStorage.setItem("user", JSON.stringify(user));
          this.$emit("input", false);
          this.$emit("saved");
        } else {
          this.errorMsg = (result.data && result.data.message) || "บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่";
        }
      } catch (error) {
        this.errorMsg =
          (error.response && error.response.data && error.response.data.message) ||
          "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.dialog-header {
  background: linear-gradient(135deg, #455a64 0%, #455a64 100%);
  display: flex;
  align-items: center;
}

.dialog-header h3 {
  font-size: 1.4rem;
  font-weight: 600;
}

.dialog-header .subtitle {
  font-size: 0.88rem;
  opacity: 0.9;
}
</style>
